module.exports = __webpack_public_path__ + "img/sld_grid_ta1_dark.622925e6.svg";